export enum ImportConfigurationEnum {
  None = 0,
  Barings,
  Sal,
  Axa,
  France,
  OneReport,
  UsReport
}
